import { CreateProjectHeadSteps } from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectHead/CreateProjectHeadSteps';
import { CreateProjectHeadConstants } from 'src/pages/ProjectPage/CreateProjectSteps/CreateProjectHead/CreateProjectHeadConstants';
import { clsx } from 'clsx';

// `titleIndex` picks the heading from CreateProjectHeadConstants; a falsy `step` hides the step dots.
export const CreateProjectHead = ({ step, titleIndex }: { step: number; titleIndex: number }) => {
  return (
    <div className={'flex flex-col w-full items-center max-w-[600px] gap-7.5'}>
      <div className={clsx('flex flex-row gap-1.5 py-3', !step && 'invisible')}>
        <CreateProjectHeadSteps step={step} />
      </div>
      <div className={'flex flex-col gap-1.5'}>
        <h1 className={'font-jamjuree uppercase text-[1.375rem] font-bold text-black text-center'}>
          {CreateProjectHeadConstants[titleIndex]?.title || ''}
        </h1>
        <p className={'font-jamjuree text-ebony_opacity_50 text-center font-medium'}>
          {CreateProjectHeadConstants[titleIndex]?.description || ''}
        </p>
      </div>
    </div>
  );
};
